import { guid } from '@/mixins/guid';

export default function googleMap() {
  return {
    _id: false,
    type: 'droplet.googleMap',
    map: {
      baseColor: 'default',
      useBg: true,
      markers: [
        {
          _id: guid.methods.guid(),
          lat: 29.425967,
          lng: -98.486142,
          title: 'The Alamo',
          markerImg: `${process.env.S3_ASSETS_URL}mock-images/icons/maps-default-pin.svg`,
          address: 'The Alamo, San Antonio Tx',
        },
      ],
    },
    mediaQueries: [
      {
        selector: '.drzMap-address',
        properties: [
          {
            defaultColor: true,
            property: 'background-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
    ],
    pageCSS: '',
    showAddress: false,
    bounceDroplet: false,
    firstDrop: true,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/google-map/droplet.schema.js